<div appWindowHeight (windowWidth)="setWidth($event)" (defaultHeights)="setHeight($event)" id="scrollingItem">
  <app-loader *ngIf="isLoading" [loaderMsg]="'Loading Rooms...'"></app-loader>
  <!-- Room Filter Mat card starts here. It is prepopulated with res data-->
  <mat-card class="filter_content">
    <mat-card-content>
      <mat-form-field class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
        <mat-date-range-input [rangePicker]="picker" [min]="configService.configDetailsData.currentHotelDate">
          <input
            #selectArrivalDate="ngModel"
            readonly
            matStartDate
            name="arrivalDate"
            placeholder="{{ rGuestBookMessages?.groups?.delegateExcelArrivalDateHeader }}"
            [(ngModel)]="arrivalDate"
            required />
          <input
            #selectDepartureDate="ngModel"
            readonly
            matEndDate
            name="departureDate"
            placeholder="{{ rGuestBookMessages?.groups?.delegateExcelDepDateHeader }}"
            [(ngModel)]="departureDate"
            required />
        </mat-date-range-input>
        <button
          *ngIf="(reservationData?.canBeAllowedToModify?.[0]?.arrivalDate) || (reservationData?.canBeAllowedToModify?.[0]?.departureDate)"
          mat-button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          [matTooltip]="rGuestBookMessages?.rooms?.refreshPlaceholder || 'Reset'"
          (click)="resetDatePicker(); $event.stopPropagation()">
          <mat-icon aria-label="Revert Dates">undo</mat-icon>
        </button>
        <mat-datepicker-toggle matSuffix [for]="picker"> </mat-datepicker-toggle>
        <mat-date-range-picker
          #picker
          [startAt]="arrivalDate"
          (closed)="triggerDateChanged()"
          [disabled]="(!reservationData?.canBeAllowedToModify?.[0]?.arrivalDate) && (!reservationData?.canBeAllowedToModify?.[0]?.departureDate)">
        </mat-date-range-picker>
      </mat-form-field>

      <mat-form-field class="col-xs-12 col-sm-12 col-md-6 col-lg-3" *ngIf="!configService?.multiGuestType">
        <mat-select
          placeholder="{{ rGuestBookMessages?.rooms?.roomNoOfGuestPlaceholder || 'No Of Guest' }}"
          [(ngModel)]="guestAdultCount"
          [disabled]="(!reservationData?.canBeAllowedToModify?.[0].noOfAdults)"
          (selectionChange)="getRooms()">
          <mat-option [value]="1">1</mat-option>
          <mat-option [value]="2">2</mat-option>
          <mat-option [value]="3">3</mat-option>
          <mat-option [value]="4">4</mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="configService?.multiGuestType" class="grid-wrapper">
        <ng-container *ngFor="let detail of configService?.guestTypeLimit">
          <mat-form-field class="filter-fields col-xs-12 col-sm-12 col-md-6 col-lg-3">
            <!-- as of now from end there is no key for noOfDiscChild we may need to configure it -->
            <mat-select
              [disabled]="(detail?.key === GuestCountKeys.noOfAdults) ? (!reservationData?.canBeAllowedToModify?.[0].noOfAdults) 
             : (detail?.key === GuestCountKeys.noOfJuniors) ? (!reservationData?.canBeAllowedToModify?.[0].noOfJuniors) 
             : (detail?.key === GuestCountKeys.noOfChildren) ? (!reservationData?.canBeAllowedToModify?.[0].noOfChildren) 
             : (detail?.key === GuestCountKeys.noOfInfants) ? (!reservationData?.canBeAllowedToModify?.[0].noOfInfants) 
             : (detail?.key === GuestCountKeys.noOfDiscChild) ? (!reservationData?.canBeAllowedToModify?.[0].noOfDiscChild) : ''"
              [placeholder]="detail.label"
              [(ngModel)]="
                detail?.key === GuestCountKeys.noOfAdults
                  ? guestAdultCount
                  : detail?.key === GuestCountKeys.noOfJuniors
                  ? guestJuniorCount
                  : detail?.key === GuestCountKeys.noOfChildren
                  ? guestChildCount
                  : detail?.key === GuestCountKeys.noOfInfants
                  ? guestInfantCount
                  : guestDiscInfantCount
              "
              [matTooltip]="detail.toolTip"
              (selectionChange)="getGuestDetails(detail, $event)">
              <mat-option *ngFor="let val of fetchValues(detail)" [value]="val">{{ val }} </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </ng-container>

      <!-- Casino Number can not be modified during update process-->
      <mat-form-field
        class="filter-fields col-xs-12 col-sm-12 col-md-6 col-lg-3"
        *ngIf="rGuestBookRoutePermissions?.functionalPermissions?.casinoNumber_casinoNumberRoomsPage">
        <input
          type="text"
          id="roomcasinonumber"
          [placeholder]="rGuestBookMessages?.rooms?.roomCasinoNumberPlaceholder || 'Casino Number'"
          matInput
          disabled
          [(ngModel)]="casinoNumber"
          (change)="getRooms()"
          #casinoNoRef="ngModel"
          pattern="[a-zA-Z0-9 #\-]*"
          name="casinoNo" />
      </mat-form-field>

      <!-- Offer Code can not be modified during update process-->
      <mat-form-field
        class="filter-fields col-xs-12 col-sm-12 col-md-6 col-lg-3"
        *ngIf="rGuestBookRoutePermissions?.functionalPermissions?.offerCode_offerCodeRoomsPage">
        <input
          name="offerCode"
          [(ngModel)]="offerCode"
          id="roomoffercodeselect"
          matInput
          disabled
          (change)="getRooms()"
          #offerCodeRef="ngModel"
          [placeholder]="rGuestBookMessages?.rooms?.roomOfferCodePlaceholderViewOnly || 'Offer Code'" />
      </mat-form-field>
    </mat-card-content>
  </mat-card>

  <!-- Room List Content Starts-->
  <ng-container *ngIf="!errorPopup">
    <div
      (deferLoad)="room.showImage = true"
      *ngFor="let room of filteredItems | roomorder: rGuestBookRoutePermissions.functionalPermissions?.shownBestRateRibbon; let i = index"
      id="room-panel{{ i }}"
      class="roomBlock animated zoomIn col-xs-12 col-sm-12 col-md-6 col-lg-4">
      <ng-container *ngTemplateOutlet="bestRateRibbonBlock; context: { room: room }"></ng-container>

      <ng-container *ngTemplateOutlet="roomSoldOutBlock; context: { room: room }"></ng-container>
      <ng-container *ngTemplateOutlet="roomSelectedAlreadyBlock; context: { room: room }"></ng-container>
      <ng-container *ngTemplateOutlet="roomCurrenlySelectedBlock; context: { room: room }"></ng-container>

      <div class="book-button-link">
        <ng-container *ngTemplateOutlet="selectRoomButtonBlock; context: { room: room }"></ng-container>
      </div>

      <div *ngIf="filteredItems" (click)="showDetails(room, i)" class="RoomCard">
        <div id="mat-card{{ i }}">
          <div id="hover-content">
            {{ rGuestBookMessages?.rooms?.roomViewDetails || "View Details" }}
          </div>

          <ng-container *ngTemplateOutlet="roomImageBlock; context: { room: room }"></ng-container>

          <div
            class="roomleftmsg"
            *ngIf="
              room?.rateSnapshot[0].showRemainingRooms &&
              room?.rateSnapshot[0]?.nightAvailable &&
              !rGuestBookRoutePermissions.functionalPermissions?.hideInventoryCount
            ">
            <p class="hurry-text">
              {{ rGuestBookMessages?.rooms?.roomHurryMessage1 || "Hurry..Only" }}
              <span *ngIf="showRemainingRoomsCount && room?.rateSnapshot[0].remainingRooms > 0">
                {{ room?.rateSnapshot[0].remainingRooms }}
              </span>
              <span *ngIf="showRemainingRoomsCount && room?.rateSnapshot[0].remainingRooms <= 0">
                {{ rGuestBookMessages?.rooms?.roomHurryMessage2 || "few" }}
              </span>
              <span *ngIf="!showRemainingRoomsCount">{{ rGuestBookMessages?.rooms?.roomHurryMessage2 || "few" }}</span
              >{{ rGuestBookMessages?.rooms?.roomHurryMessage3 || "room(s) left." }}
            </p>
          </div>
        </div>

        <div class="title-card">
          <div id="roomNameCard" class="pull-left rate-style rpageroomname">
            {{ room.roomName | pcapitalize: disableCapitalizePipe }}
          </div>
          <div class="space"></div>
          <div *ngIf="!room.isPackage">
            <div *ngIf="room.blockRoom == false" class="rate-wrap mobile-head-rate rate-style">
              <div *ngIf="room.days == room.compDays">
                <p>{{ rGuestBookMessages?.rooms?.roomComplementaryMessage || "Your stay is Complimentary" }}</p>
                <span class="notice">{{
                  rGuestBookMessages?.rooms?.roomRecurringChargeTaxMessage || "*recurring charges and taxes as applicable"
                }}</span>
              </div>

              <div [hidden]="room.days == room.compDays">
                <span class="rate-style">{{ rGuestBookMessages?.rooms?.roomRatesMessage1 || "Rates from" }}</span
                >{{
                  (room.minRate || 0) * newRate
                    | custCurrency
                      : this.currencyCode || configService?.PropertyData?.currencyCode
                      : this.countryCode || configService?.PropertyData?.countryCode
                }}
                <span class="rate-style post-style">{{ rGuestBookMessages?.rooms?.roomRatesMessage2 || "/night" }}</span>

                <p class="rate-style" *ngIf="room.hasComp">
                  {{ rGuestBookMessages?.rooms?.roomRatesMessage3 || "with" }}
                  <span>{{ room.compDays }}</span
                  >{{ rGuestBookMessages?.rooms?.roomRatesMessage4 || " Complimentary night(s)" }}
                </p>
              </div>
            </div>
            <div
              class="rate-wrap mobile-head-rate"
              *ngIf="room.blockRoom == true && room.minRate != 0.0 && !hideRateDepositAndCancelPoliciesIfSoldOut">
              <p class="soldOut">
                {{ rGuestBookMessages?.rooms?.roomRatesMessage5 || "You missed it !" }}
                <span class="rate-style" [hidden]="room.days == room.compDays">
                  {{ rGuestBookMessages?.rooms?.roomRatesMessage6 || " Sold for" }}
                  {{
                    (room.minRate || 0) * newRate
                      | custCurrency
                        : this.currencyCode || configService?.PropertyData?.currencyCode
                        : this.countryCode || configService?.PropertyData?.countryCode
                  }}
                  {{ rGuestBookMessages?.rooms?.roomRatesMessage7 || "/night" }}
                </span>
                <span [hidden]="room.days != room.compDays">{{ rGuestBookMessages?.rooms?.roomRatesMessage8 || " RoomSold Out" }}</span>
              </p>
            </div>
            <div
              *ngIf="room.blockRoom == true && room.minRate != 0.0 && hideRateDepositAndCancelPoliciesIfSoldOut"
              class="rate-wrap mobile-head-rate">
              <p class="soldOut">
                {{ rGuestBookMessages?.rooms?.roomRatesMessage5 || "You missed it !" }}
              </p>
            </div>
            <div *ngIf="room.blockRoom == true && room.minRate == 0.0" class="rate-wrap mobile-head-rate">
              <p class="soldOut">{{ rGuestBookMessages?.rooms?.roomRatesMessage9 || "You have missed the Complimentary stay" }}</p>
            </div>
          </div>
          <div *ngIf="room.isPackage">
            <div class="rate-wrap mobile-head-rate">
              {{
                (room.quoteTotal || 0) * newRate
                  | custCurrency
                    : this.currencyCode || configService?.PropertyData?.currencyCode
                    : this.countryCode || configService?.PropertyData?.countryCode
              }}
            </div>
          </div>
          <div *ngIf="room.previousPlayerStay" class="pull-left">
            <span class="playerstay">{{ rGuestBookMessages?.rooms?.roomLastTimeMessage || "Last time you stayed here !" }}</span>
          </div>
        </div>
      </div>
      <div id="showArrow{{ i }}" class="showArrow arrow-down"></div>
    </div>
  </ng-container>

  <div class="clearfix mb-2"></div>
</div>

<!--Room Details Popup Displays-->
<div id="detailstab" class="detailstab" [hidden]="!details_tab" *ngIf="filteredItems.length > 0">
  <div *ngIf="details_tab && filteredItems.length > 0">
    <h3 class="room_name">{{ selectedTab.roomName | pcapitalize: disableCapitalizePipe }}</h3>

    <button id="closeRoomDetails" class="close-details" (click)="closeTab(selectedTab)" mat-fab>
      <i class="fa fa-times fa-close-button" aria-hidden="true"></i>
    </button>

    <button class="close-details-mini" (click)="closeTab(selectedTab)" mat-fab id="closeDetailsMini">
      <i class="fa fa-times fa-close-button" aria-hidden="true"></i>
    </button>

    <div class="grid-wrapper">
      <div class="p-10 col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <ng-container *ngTemplateOutlet="roomImageCarousel"></ng-container>

        <div *ngIf="selectedTab" class="row">
          <div class="col mt-3">
            <button disableRipple="true" *ngIf="!selectedTab.isPackage" mat-raised-button class="rate-details-wrap nohover">
              <div *ngIf="selectedTab.days == selectedTab.compDays && !selectedTab.blockRoom">
                <p>{{ rGuestBookMessages?.rooms?.roomComplementaryMessage || " Your stay is Complimentary " }}</p>
                <span class="notice-tab">{{
                  rGuestBookMessages?.rooms?.roomRecurringChargeTaxMessage || "*recurring charges and taxes as applicable"
                }}</span>
              </div>
              <div *ngIf="selectedTab.days == selectedTab.compDays && selectedTab.blockRoom">
                <p>{{ rGuestBookMessages?.rooms?.roomRatesMessage10 || " You Missed it! RoomSold Out " }}</p>
              </div>
              <div class="rate-style" *ngIf="selectedTab.days != selectedTab.compDays && !selectedTab.blockRoom">
                <span class="rate-style">{{ rGuestBookMessages?.rooms?.roomRatesMessage1 || "Rates from " }}</span>
                {{
                  (selectedTab.minRate || 0) * newRate
                    | custCurrency
                      : this.currencyCode || configService?.PropertyData?.currencyCode
                      : this.countryCode || configService?.PropertyData?.countryCode
                }}
                <span class="rate-style post-style">{{ rGuestBookMessages?.rooms?.roomRatesMessage2 || "/night" }}</span>
                <p class="rate-style" *ngIf="selectedTab.hasComp">
                  {{ rGuestBookMessages?.rooms?.roomRatesMessage3 || "with" }}

                  <span>{{ selectedTab.compDays }}</span
                  >{{ rGuestBookMessages?.rooms?.roomRatesMessage11 || " Complimentary stay" }}
                </p>
              </div>
              <div *ngIf="selectedTab.days != selectedTab.compDays && selectedTab.blockRoom == true">
                <span class="rate-style">{{ rGuestBookMessages?.rooms?.roomRatesMessage10 || " You Missed it! RoomSold Out " }}</span>
                <div class="text-left">
                  <span class="rate-style rateStyle"
                    >{{
                      (selectedTab.minRate || 0) * newRate
                        | custCurrency
                          : this.currencyCode || configService?.PropertyData?.currencyCode
                          : this.countryCode || configService?.PropertyData?.countryCode
                    }}
                    {{ rGuestBookMessages?.rooms?.roomRatesMessage7 || "/night" }}</span
                  >
                </div>
              </div>
            </button>
            <button
              mat-raised-button
              *ngIf="selectedTab.isPackage"
              class="policy-button btn-book-disable"
              (click)="openCanellationDepositPolicy(selectedTab)">
              <i class="fa fa-file-text-o" aria-hidden="true"></i>
              {{ rGuestBookMessages?.rooms?.roomDepCanPolicy || "Deposit and Cancellation Policy" }}
            </button>
          </div>
          <div class="col mt-3 button-alignment custom-button-alignment">
            <ng-container *ngTemplateOutlet="selectRoomButtonBlock; context: { room: selectedTab }"></ng-container>
          </div>
        </div>
        <div *ngIf="!selectedTab.isPackage && !(room?.blockRoom && hideRateDepositAndCancelPoliciesIfSoldOut)" class="deposit-cancel">
          <button
            #depositAndCancellationBtn
            id="depositAndCancellationBtn"
            class="policy-button btn-book-disable"
            mat-raised-button
            (click)="openCanellationDepositPolicy(selectedTab)">
            <i class="fa fa-file-text-o mr-6" aria-hidden="true"></i
            >{{ rGuestBookMessages?.rooms?.roomDepCanPolicy || "Deposit and Cancellation Policy" }}
          </button>
        </div>
      </div>
      <div class="details-all col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <mat-tab-group [selectedIndex]="0" class="mat-tab-group-style">
          <mat-tab
            *ngIf="selectedTab && (selectedTab.expandedDescription || selectedTab.maxOccupancy || selectedTab.size)"
            label="{{ rGuestBookMessages?.rooms?.roomDetailsTabName1 || 'RoomDetails' }}">
            <p class="expanded_description custom-expanded_description" [innerHTML]="selectedTab.expandedDescription | safeHtml"></p>
            <div
              class="col-lg-12 col-sm-12 col-xs-12 mr-zero mb-2 additiondetils"
              *ngIf="selectedTab.customFields && selectedTab.customFields.length">
              <a>
                <span *ngIf="!showMore" (click)="showMore = true" class="additiondetilslabel">
                  {{ rGuestBookMessages?.rooms?.roomAdditionalsDetailsShow || "Show Additional Details" }}
                  <i aria-hidden="true" class="fas fa-chevron-circle-down"></i>
                </span>
                <span *ngIf="showMore" (click)="showMore = false" class="additiondetilslabel">
                  {{ rGuestBookMessages?.rooms?.roomAdditionalsDetailsHide || " Hide Additional Details" }}
                  <i aria-hidden="true" class="fas fa-chevron-circle-up"></i>
                </span>
              </a>
              <br />
              <ng-container *ngIf="showMore">
                <ng-container *ngFor="let cfield of selectedTab.customFields">
                  <div>
                    <h4 class="font-weight-bold mb-1">{{ cfield.name }}</h4>
                  </div>
                  <div class="indentedText mb-1 pl-2" [innerHTML]="cfield.shortDesc | safeHtml"></div>
                  <div class="indentedText mb-1 pl-2" [innerHTML]="cfield.longDesc | safeHtml"></div>
                </ng-container>
              </ng-container>
            </div>
            <div class="row mr-zero">
              <div class="col-lg-6 col-sm-6 col-xs-12">
                <div *ngIf="selectedTab && selectedTab.maxOccupancy" class="mb-2">
                  <p class="font-weight-bold mb-1">{{ rGuestBookMessages?.rooms?.roomMaxOccupancy || "Maximum Occupancy" }}</p>
                  <div class="indentedText mb-1 pl-2 unset-pl">
                    {{ selectedTab.maxOccupancy }} {{ rGuestBookMessages?.rooms?.roomDetailsPeople || "People" }}
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-xs-12">
                <div *ngIf="selectedTab && selectedTab.size">
                  <p class="font-weight-bold mb-1">{{ rGuestBookMessages?.rooms?.roomSize || "Size" }}</p>
                  <div class="indentedText mb-1 pl-2 unset-pl">
                    {{ selectedTab.size }} <span *ngIf="selectedTab.measurement">{{ selectedTab.measurement }}</span>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab *ngIf="selectedTab.isPackage" label="{{ rGuestBookMessages?.rooms?.roomDetailsTabName2 || 'Package Details' }}">
            <div class="p-40">
              <div>
                <span class="packageIncludeBlock">{{ rGuestBookMessages?.rooms?.roomPackageIncludesMessage || "Package includes:" }}</span>
              </div>
              <div class="p-20">
                <div *ngFor="let description of data?.offers?.[0].offerDescriptionExpArray">
                  <p *ngIf="description?.length">
                    <i class="fa fa-dot-circle-o" aria-hidden="true"></i> &nbsp;<span [innerHtml]="description | safeHtml"></span>
                  </p>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab
            *ngIf="selectedTab.blockRoom == false && !selectedTab.isPackage"
            label="{{ rGuestBookMessages?.rooms?.roomDetailsTabName3 || 'Rate Breakdown' }}">
            <div *ngIf="details_tab">
              <div class="rate_flows">
                <div class="table-responsive mt-10">
                  <table aria-hidden="true" class="rate_table table table-hover">
                    <thead class="rate_table_head">
                      <tr>
                        <ng-container *ngFor="let th of room.thead">
                          <th
                            id="rate_table_header_1"
                            *ngIf="
                              th == 'roomTheadResortFee' &&
                              !rGuestBookRoutePermissions.functionalPermissions?.hideZeroResortFees &&
                              !room.resortFeeTotal
                            ">
                            {{ rGuestBookMessages?.rooms[th] || th }}
                          </th>
                          <th
                            id="rate_table_header_2"
                            *ngIf="th == 'roomTheadResortFee' && room.resortFeeTotal && room.resortFeeTotal != 0">
                            {{ rGuestBookMessages?.rooms[th] || th }}
                          </th>
                          <th
                            id="rate_table_header_3"
                            *ngIf="
                              th == 'roomTheadOtherFee' &&
                              !rGuestBookRoutePermissions.functionalPermissions?.hideZeroOtherFees &&
                              !room.recurringChargesTotal
                            ">
                            {{ rGuestBookMessages?.rooms[th] || th }}
                          </th>
                          <th
                            id="rate_table_header_4"
                            *ngIf="th == 'roomTheadOtherFee' && room.recurringChargesTotal && room.recurringChargesTotal != 0">
                            {{ rGuestBookMessages?.rooms[th] || th }}
                          </th>
                          <th id="rate_table_header_5" *ngIf="th != 'roomTheadResortFee' && th != 'roomTheadOtherFee'">
                            {{ rGuestBookMessages?.rooms[th] || th }}
                          </th>
                        </ng-container>
                      </tr>
                    </thead>
                    <tbody class="rate_table_head">
                      <tr *ngFor="let rates of room.tbody">
                        <td>{{ rates.date | custDate: configService?.PropertyData?.dateFunctionConfig }}</td>
                        <td class="text-right" *ngIf="rates.roomRate > 0">
                          <span>{{
                            (rates.roomRate || 0) * newRate
                              | custCurrency
                                : this.currencyCode || configService?.PropertyData?.currencyCode
                                : this.countryCode ||
                                    configService?.PropertyData?.countryCode ||
                                    rGuestBookMessages?.rooms?.roomRateBreakdownText1 ||
                                    "Comp"
                          }}</span>
                        </td>
                        <td class="text-right" *ngIf="rates.roomRate <= 0">
                          {{ rGuestBookMessages?.rooms?.roomRateBreakdownText2 || "Complimentary" }}
                        </td>
                        <td
                          class="text-right"
                          *ngIf="!rGuestBookRoutePermissions.functionalPermissions?.hideZeroResortFees && !room.resortFeeTotal">
                          <span>{{
                            (rates.resortCharges || 0) * newRate
                              | custCurrency
                                : this.currencyCode || configService?.PropertyData?.currencyCode
                                : this.countryCode || configService?.PropertyData?.countryCode || "-"
                          }}</span>
                        </td>
                        <td class="text-right" *ngIf="room.resortFeeTotal && room.resortFeeTotal != 0">
                          <span>{{
                            (rates.resortCharges || 0) * newRate
                              | custCurrency
                                : this.currencyCode || configService?.PropertyData?.currencyCode
                                : this.countryCode || configService?.PropertyData?.countryCode || "-"
                          }}</span>
                        </td>
                        <td
                          class="text-right"
                          *ngIf="
                            room.thead.includes('roomTheadOtherFee') &&
                            !rGuestBookRoutePermissions.functionalPermissions?.hideZeroOtherFees &&
                            !room.recurringChargesTotal
                          ">
                          <span>{{
                            (rates.otherCharges || 0) * newRate
                              | custCurrency
                                : this.currencyCode || configService?.PropertyData?.currencyCode
                                : this.countryCode || configService?.PropertyData?.countryCode || "-"
                          }}</span>
                        </td>
                        <td class="text-right" *ngIf="room.recurringChargesTotal && room.recurringChargesTotal != 0">
                          <span>{{
                            (rates.otherCharges || 0) * newRate
                              | custCurrency
                                : this.currencyCode || configService?.PropertyData?.currencyCode
                                : this.countryCode || configService?.PropertyData?.countryCode || "-"
                          }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <div class="row">
                    <h5 class="total_amount col-6 col-sm-6 col-md-6 col-lg-6">
                      <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText3 || "RoomTotal:" }}</strong>
                    </h5>
                    <h5 *ngIf="room.days != room.compDays" class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-3">
                      {{
                        (room.roomTotal || 0) * newRate
                          | custCurrency
                            : this.currencyCode || configService?.PropertyData?.currencyCode
                            : this.countryCode || configService?.PropertyData?.countryCode
                      }}
                    </h5>
                    <h5 *ngIf="room.days == room.compDays" class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-3">
                      {{ rGuestBookMessages?.rooms?.roomRateBreakdownText2 || "Complimentary" }}
                    </h5>
                    <h5 *ngIf="room.recurringChargesTotal > 0" class="total_amount col-6 col-sm-6 col-md-6 col-lg-6">
                      <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText4 || "Other Fee Total: " }}</strong>
                    </h5>
                    <h5 *ngIf="room.recurringChargesTotal > 0" class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-3">
                      {{
                        (room.recurringChargesTotal || 0) * newRate
                          | custCurrency
                            : this.currencyCode || configService?.PropertyData?.currencyCode
                            : this.countryCode || configService?.PropertyData?.countryCode
                      }}
                    </h5>
                  </div>
                  <div class="row" *ngIf="!rGuestBookRoutePermissions.functionalPermissions?.hideZeroResortFees && !room.resortFeeTotal">
                    <h5 class="total_amount col-6 col-sm-6 col-md-6 col-lg-6">
                      <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText5 || "Resort Fee Total: " }}</strong>
                    </h5>
                    <h5 class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-3">
                      {{
                        (room.resortFeeTotal || 0) * newRate
                          | custCurrency
                            : this.currencyCode || configService?.PropertyData?.currencyCode
                            : this.countryCode || configService?.PropertyData?.countryCode
                      }}
                    </h5>
                  </div>
                  <div *ngIf="room.resortFeeTotal && room.resortFeeTotal != 0" class="row">
                    <h5 class="total_amount col-6 col-sm-6 col-md-6 col-lg-6">
                      <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText5 || "Resort Fee Total: " }}</strong>
                    </h5>
                    <h5 class="total_amount total_value col-5 col-sm-5 col-md-5 col-lg-3">
                      {{
                        (room.resortFeeTotal || 0) * newRate
                          | custCurrency
                            : this.currencyCode || configService?.PropertyData?.currencyCode
                            : this.countryCode || configService?.PropertyData?.countryCode
                      }}
                    </h5>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <h5 class="col-6 col-sm-6 col-md-6 col-lg-6 grand_total grand_title">
                    <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText6 || " Total:" }}</strong>
                    <p>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText7 || "(*Exclusive of taxes)" }}</p>
                  </h5>
                  <h5 *ngIf="room.quoteTotal > 0" class="ml-5 col-5 col-sm-5 col-md-5 col-lg-3 grand_total grand_total_value">
                    {{
                      (room.quoteTotal || 0) * newRate
                        | custCurrency
                          : this.currencyCode || configService?.PropertyData?.currencyCode
                          : this.countryCode || configService?.PropertyData?.countryCode
                    }}
                  </h5>
                  <h5 *ngIf="room.quoteTotal == 0" class="col-5 col-sm-5 col-md-5 col-lg-3 grand_total grand_total_value">
                    {{ rGuestBookMessages?.rooms?.roomRateBreakdownText8 || "Complimentary" }}
                  </h5>
                </div>
                <hr class="mt-0" />
                <div class="row">
                  <h5 class="col-6 col-sm-6 col-md-6 col-lg-6 grand_total grand_title">
                    <strong>{{ rGuestBookMessages?.rooms?.roomRateBreakdownText9 || " Deposit Amount Required:" }}</strong>
                  </h5>
                  <h5 class="col-5 col-sm-5 col-md-5 col-lg-3 ml-5 grand_total grand_total_value">
                    {{
                      (room.depositAmountDue || 0) * newRate
                        | custCurrency
                          : this.currencyCode || configService?.PropertyData?.currencyCode
                          : this.countryCode || configService?.PropertyData?.countryCode
                    }}
                  </h5>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab
            *ngIf="details_tab && selectedTab.amenities && selectedTab.amenities.length > 0"
            label="{{ rGuestBookMessages?.rooms?.roomDetailsTabName4 || 'Amenities' }}">
            <div class="outer-tab-layer grid-wrapper">
              <div class="col-md-6 col-lg-6 amenities-outer" *ngFor="let amenities of selectedTab.amenities">
                <p class="amenities">{{ amenities }}</p>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>

<div *ngIf="errorPopup" class="p-10">
  <div class="alert alert-warning">
    <strong>{{ errorPopup }}</strong>
    <div *ngIf="hasInvalidDates" class="mt-10">
      <button
        *ngIf="rGuestBookRoutePermissions.functionalPermissions?.togglefilterButtonToTop"
        mat-button
        class="button-color filter-top-button filter-top-button-onError"
        data-dismiss="modal"
        data-toggle="modal"
        href="#filter-model">
        {{ rGuestBookMessages?.rooms?.roomTabFilterText || "Filter" }}
      </button>
    </div>
  </div>
</div>

<ng-template #roomImageBlock let-room="room">
  <div *ngIf="room.roomsImages" class="image-scroll">
    <div id="carousel-id{{ i }}" data-ride="carousel" [class.loaderOverlay-comp-bg]="room.alreadySelected" class="roomCardImage slide">
      <ng-container *ngIf="room.showImage">
        <img
          alt="{{ room.roomsImages[0] }}"
          (error)="errorRoomImageHandler(room, $event, room.roomCode, room.roomsImages[0], true, i)"
          [src]="assetsURL + 'rooms/' + (room.roomCode | azurefolder) + '/' + (room.roomsImages[0] | azurefolder) | azureBlobToken" />
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #roomImageCarousel>
  <div
    *ngIf="selectedTab.roomsImages"
    id="carousel-room-id"
    class="carousel_slider carousel carouselCardImage slide carousel_room"
    data-ride="carousel">
    <ol class="carousel-indicators" *ngIf="selectedTab.roomsImages.length > 1">
      <ng-container *ngFor="let img of selectedTab.roomsImages; let ii = index">
        <li [attr.data-target]="'#carousel-room-id'" [attr.data-slide-to]="ii" [class.active]="ii == 0" *ngIf="img != ''"></li>
      </ng-container>
    </ol>
    <div id="shopping-slider" class="carousel-inner carouselCardImageContainer">
      <ng-container *ngFor="let img of selectedTab.roomsImages; let ii = index">
        <div class="img-slide item carousel-item" [class.active]="ii == 0">
          <img
            class="carousel_slider"
            [src]="assetsURL + 'rooms/' + (room.roomCode | azurefolder) + '/' + (img | azurefolder) | azureBlobToken"
            [attr.alt]="selectedTab.roomName"
            (error)="errorRoomImageHandler(selectedTab, $event, selectedTab.roomCode, img, false, ii)" />
        </div>
      </ng-container>
      <div class="img-slide item active" *ngIf="selectedTab.roomsImages.length == 0">
        <img [src]="defaultRoomImageURL | azureBlobToken" [attr.alt]="selectedTab.roomName" />
      </div>
    </div>
    <ng-container *ngIf="selectedTab.roomsImages.length > 1">
      <a class="carousel-control-prev" [attr.href]="'#carousel-room-id'" data-slide="prev">
        <i aria-hidden="true" class="carousel-control-prev-icon"></i>
      </a>
      <a class="carousel-control-next" [attr.href]="'#carousel-room-id'" data-slide="next">
        <i aria-hidden="true" class="carousel-control-next-icon"></i>
      </a>
    </ng-container>
  </div>
</ng-template>

<ng-template #bestRateRibbonBlock let-room="room">
  <div
    class="ribbonRoom"
    *ngIf="room?.hasComp && !room?.blockRoom && rGuestBookRoutePermissions?.functionalPermissions?.shownBestRateRibbon">
    <span>{{ rGuestBookMessages?.rooms?.bestRateRibbonText || "Best Value Pack" }}</span>
  </div>
</ng-template>

<ng-template #roomSoldOutBlock let-room="room">
  <div class="room-blocked block-container" *ngIf="room?.blockRoom">
    <h2 class="text-soldout">{{ rGuestBookMessages?.rooms?.roomSoldOut || "Sold Out" }}</h2>
  </div>
</ng-template>

<ng-template #roomSelectedAlreadyBlock let-room="room">
  <div class="room-blocked block-container" *ngIf="room?.alreadySelected">
    <h2 class="text-soldout">{{ rGuestBookMessages?.rooms?.alreadySelectedText || "Already Selected" }}</h2>
  </div>
</ng-template>

<ng-template #roomCurrenlySelectedBlock let-room="room">
  <div class="room-blocked block-container" *ngIf="!room?.alreadySelected && updatedRoomCode == room?.roomCode && !room?.blockRoom">
    <h2 class="text-soldout">{{ rGuestBookMessages?.rooms?.currentlySelectedText || "Currently Selected" }}</h2>
  </div>
</ng-template>

<ng-template #selectRoomButtonBlock let-room="room">
  <!-- Disable the button in case of Sold out room, Already Selected Room or newly Selected Room -->
  <button
    *ngIf="!(!room?.alreadySelected && updatedRoomCode == room?.roomCode && !room?.blockRoom)"
    [disabled]="room?.blockRoom || room?.alreadySelected"
    [class.btn-book-disable]="room?.blockRoom || room?.alreadySelected"
    (click)="selectRoom(room)"
    class="btn-book"
    mat-raised-button
    color="primary">
    {{ rGuestBookMessages?.rooms?.roomIndividualCardBookButtonUpdate || "Select" }}
  </button>
  <!-- deselect newly selected room -->
  <button
    *ngIf="!room?.alreadySelected && updatedRoomCode == room?.roomCode && !room?.blockRoom"
    [disabled]="room?.blockRoom || room?.alreadySelected"
    [class.btn-book-disable]="room?.blockRoom || room?.alreadySelected"
    (click)="deSelectRoom(room)"
    class="refactor-space-issue refactor-ml-4"
    mat-raised-button
    color="warn">
    <i class="fa fa-remove mr-2" aria-hidden="true"></i>{{ "Remove" }}
  </button>
</ng-template>
